export class ResultModel<T> {
	array: T[];
	data: T;
	error: string;
	error_description: string;
	has_error: boolean;
	total: number;
}
